export default __webpack_public_path__ + "static/73eb05f55bf4f69cbe3dce94c7bfe753.png";